import { firebase } from "../config/configureFirebase";
import { FareCalculator } from "../other/FareCalculator";
import { GetDistance, GetTripDistance } from "../other/GeoFunctions";
import { fetchAddressfromCoords } from '../other/GoogleAPIFunctions';
import store from '../store/store';
import { onValue, child, push, query, update, get, orderByKey } from "firebase/database";

export const formatBookingObject = async (bookingData, settings) => {
  const c = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const reference = [...Array(6)].map(_ => c[~~(Math.random() * c.length)]).join('');

  const { config, appcat } = firebase;
  let today;
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 3000);
    let res = await fetch(`https://${config.projectId}.web.app/getservertime`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      signal: controller.signal
    });
    clearTimeout(timeoutId);
    const json = await res.json();
    if (json.time) {
      today = json.time;
    } else {
      today = new Date().getTime();
    }
  } catch (err) {
    today = new Date().getTime();
  }

  let pickUp = { lat: bookingData.pickup.coords.lat, lng: bookingData.pickup.coords.lng, add: bookingData.pickup.description };
  let drop = { lat: bookingData.drop.coords.lat, lng: bookingData.drop.coords.lng, add: bookingData.drop.description };

  let coords = [{ latitude: pickUp.lat, longitude: pickUp.lng }];
  if (bookingData.drop.waypointsStr) {
    bookingData.drop.waypointsStr.split("|").forEach((point) => {
      let lat = point.split(',')[0];
      let lng = point.split(',')[1];
      coords.push({ latitude: parseFloat(lat), longitude: parseFloat(lng) });
    });
  }
  coords.push({ latitude: drop.lat, longitude: drop.lng });

  var otp;
  if (bookingData.settings.otp_secure)
    otp = Math.floor(Math.random() * 9000) + 1000;
  else {
    otp = false;
  }

  return {
    carType: bookingData.carDetails.name,
    carImage: bookingData.carDetails.image,
    customer: bookingData.userDetails.uid,
    commission_type: bookingData.carDetails.convenience_fee_type,
    commission_rate: bookingData.carDetails.convenience_fees,
    reference: reference,
    customer_email: bookingData.userDetails.email,
    customer_name: bookingData.userDetails.firstName + ' ' + bookingData.userDetails.lastName,
    customer_contact: bookingData.userDetails.mobile ? bookingData.userDetails.mobile : ' ',
    customer_token: bookingData.userDetails.pushToken ? bookingData.userDetails.pushToken : ' ',
    customer_image: bookingData.userDetails.profile_image ? bookingData.userDetails.profile_image : "",
    drop: drop,
    pickup: pickUp,
    estimate: appcat === "bidcab" ? (bookingData.offerFare && bookingData.offerFare > 0) ? bookingData.offerFare : bookingData.estimate.estimateFare : bookingData.estimate.estimateFare,
    estimateDistance: bookingData.estimate.estimateDistance,
    distance: bookingData.estimate.estimateDistance,
    estimateTime: bookingData.estimate.estimateTime,
    //status: appcat === "bidcab" ? "NEW" : bookingData.booking_type_admin || (appcat === "delivery" ? bookingData.deliveryWithBid : !settings.prepaid) || bookingData.booking_type_fleetadmin ? "NEW" : "PAYMENT_PENDING",
    status: "NEW",
    bookLater: bookingData.bookLater,
    tripdate: bookingData.bookLater ? bookingData.tripdate : today,
    bookingDate: today,
    otp: otp,
    booking_type_admin: bookingData.booking_type_admin,
    coords: coords,
    waypoints: bookingData.drop.waypoints ? bookingData.drop.waypoints : null,
    roundTrip: bookingData.roundTrip ? bookingData.roundTrip : null,
    tripInstructions: bookingData.tripInstructions ? bookingData.tripInstructions : null,
    trip_cost: bookingData.estimate.estimateFare,
    convenience_fees: bookingData.estimate.convenience_fees,
    driver_share: (parseFloat(bookingData.estimate.estimateFare) - parseFloat(bookingData.estimate.convenience_fees)).toFixed(settings.decimal),
    fleet_admin_comission: bookingData.carDetails.fleet_admin_fee ? bookingData.carDetails.fleet_admin_fee : null,
    paymentPacket: bookingData.paymentPacket ? bookingData.paymentPacket : null,
    preRequestedDrivers: appcat === "bidcab" ? null : bookingData.preRequestedDrivers ? bookingData.preRequestedDrivers : null,
    requestedDrivers: bookingData.requestedDrivers ? bookingData.requestedDrivers : null,
    driverEstimates: bookingData.driverEstimates ? bookingData.driverEstimates : null,
    ...bookingData.instructionData,
    fleetadmin: bookingData.fleetadmin ? bookingData.fleetadmin : null,
    payment_mode: bookingData.payment_mode,
    booking_from_web: bookingData.booking_from_web ? bookingData.booking_from_web : false,
    deliveryWithBid: appcat === "delivery" ? bookingData.deliveryWithBid ? bookingData.deliveryWithBid : false : null,
    customer_offer: bookingData.customer_offer ? bookingData.customer_offer : bookingData.estimate.estimateFare,
    booking_type_fleetadmin: appcat === "bidcab" ? null : bookingData.booking_type_fleetadmin,
  }
}

export const saveAddresses = async (booking, driverLocation) => {
  const { singleUserRef, appcat } = firebase;
  let latlng = (driverLocation && driverLocation.lat && driverLocation.lng)
    ? driverLocation.lat + "," + driverLocation.lng
    : "0,0";

  // Resolve address safely
  const resolvedAddress = appcat === "taxi" && latlng !== "0,0"
    ? await fetchAddressfromCoords(latlng)
    : null;

  let address = resolvedAddress || booking.drop?.add || "";

  // [FIX] Ensure customer ID is a string, not an object
  const customerId = (typeof booking.customer === 'object' && booking.customer !== null)
    ? booking.customer.uid || booking.customer.id
    : booking.customer;

  if (!customerId || typeof customerId !== 'string') {
    console.warn("saveAddresses: Invalid customer ID", booking.customer);
    return address;
  }

  onValue(child(singleUserRef(customerId), "savedAddresses"), (savedAdd) => {
    if (savedAdd.val()) {
      let addresses = savedAdd.val();
      let didNotMatch = true;
      for (let key in addresses) {
        let entry = addresses[key];
        if (appcat === "taxi") {
          if (
            GetDistance(
              entry.lat,
              entry.lng,
              driverLocation.lat,
              driverLocation.lng
            ) < 0.1
          ) {
            didNotMatch = false;
            let count = entry.count ? entry.count + 1 : 1;
            update(child(singleUserRef(customerId), "savedAddresses/" + key), { count: count });
            break;
          }
        } else {
          if (
            GetDistance(
              entry.lat,
              entry.lng,
              booking.drop.lat,
              booking.drop.lng
            ) < 0.1
          ) {
            didNotMatch = false;
            let count = entry.count ? entry.count + 1 : 1;
            update(child(singleUserRef(customerId), "savedAddresses/" + key), { count: count });
            break;
          }
        }
      }
      if (didNotMatch) {
        push(child(singleUserRef(customerId), "savedAddresses"), {
          description: address,
          lat: booking.drop?.lat || 0,
          lng: booking.drop?.lng || 0,
          count: 1,
        });
      }
    } else {
      push(child(singleUserRef(customerId), "savedAddresses"), {
        description: address,
        lat: booking.drop?.lat || 0,
        lng: booking.drop?.lng || 0,
        count: 1,
      });
    }
  }, { onlyOnce: true });
  return address;
};

export const addActualsToBooking = async (booking, address, driverLocation) => {
  const { settingsRef, trackingRef, appcat } = firebase;
  const settingsdata = await get(settingsRef);
  const settings = settingsdata.val();
  const end_time = new Date();
  const diff = (end_time.getTime() - parseFloat(booking.startTime)) / 1000;
  const totalTimeTaken = Math.abs(Math.round(diff));
  if (settings.prepaid || appcat === "delivery" || appcat === "bidcab" || booking.booking_from_web) {
    booking.trip_end_time = end_time.getHours() + ":" + end_time.getMinutes() + ":" + end_time.getSeconds();
    booking.endTime = end_time.getTime();
    booking.total_trip_time = totalTimeTaken;

    // [FIX] FIXED PRICE - Do not recalculate
    booking.trip_cost = booking.estimate.estimateFare;
    booking.distance = booking.estimate.estimateDistance;
    booking.convenience_fees = booking.estimate.convenience_fees || 0;

    // Use driver location or drop location for final point
    const finalAddress = address || booking.drop?.add || "";
    booking.drop = {
      add: finalAddress,
      lat: driverLocation.lat,
      lng: driverLocation.lng,
    };
    booking.dropAddress = finalAddress;

    // Standard commission calc from fixed price
    const commRate = parseFloat(booking?.fleet_admin_comission || 0);
    const commBase = Math.max(0, parseFloat(booking?.trip_cost || 0) - parseFloat(booking?.convenience_fees || 0));
    let driver_fee = commBase;
    let fleetCommission_fee = 0;
    if (booking?.fleetadmin && commRate > 0) {
      driver_fee = parseFloat((commBase / (1 + commRate / 100)).toFixed(2));
      fleetCommission_fee = parseFloat((commBase - driver_fee).toFixed(2));
    }
    booking.fleetCommission = fleetCommission_fee ? fleetCommission_fee : 0;
    booking.driver_share = driver_fee ? driver_fee : 0;

  } else {
    booking.trip_end_time = end_time.getHours() + ":" + end_time.getMinutes() + ":" + end_time.getSeconds();
    booking.endTime = end_time.getTime();
    booking.total_trip_time = totalTimeTaken;
    let cars = store.getState().cartypes.cars;
    let rates = {};
    for (var i = 0; i < cars.length; i++) {
      if (cars[i].name == booking.carType) {
        rates = cars[i];
      }
    }
    let trackingVal = null;
    try {
      const trackingSnap = await get(query(trackingRef(booking.id), orderByKey()));
      trackingVal = trackingSnap.val();
    } catch (e) {
      console.warn("Tracking data fetch failed", e);
    }

    // [FIX] Robust calculation for METERED rides with fallbacks
    let distance = 0;
    let grandTotal = booking.estimate?.estimateFare || 0;
    let convenience_fees = booking.estimate?.convenience_fees || 0;
    let coords = booking.coords || [];

    if (trackingVal) {
      try {
        const res = await GetTripDistance(trackingVal);
        distance = settings.convert_to_mile
          ? res.distance / 1.609344
          : res.distance;

        const calc = FareCalculator(
          distance,
          totalTimeTaken,
          rates,
          null,
          settings.decimal
        );
        grandTotal = calc.grandTotal;
        convenience_fees = calc.convenience_fees;
        coords = res.coords;
      } catch (e) {
        console.warn("Distance calculation failed", e);
        // Fallback to estimate
        distance = booking.estimate?.estimateDistance || 0;
      }
    } else {
      // No tracking: use estimate
      distance = booking.estimate?.estimateDistance || 0;
      grandTotal = booking.estimate?.estimateFare || 0;
      convenience_fees = booking.estimate?.convenience_fees || 0;
    }

    booking.drop = {
      add: address,
      lat: driverLocation.lat,
      lng: driverLocation.lng,
    };
    booking.dropAddress = address;
    booking.trip_cost = grandTotal;
    booking.distance = parseFloat(parseFloat(distance).toFixed(settings.decimal));
    booking.convenience_fees = convenience_fees;
    booking.coords = coords;

    const commRateMeter = parseFloat(booking?.fleet_admin_comission || 0);
    const commBaseMeter = Math.max(0, parseFloat(booking?.trip_cost || 0) - parseFloat(booking?.convenience_fees || 0));
    let driver_fee = commBaseMeter;
    let fleetCommission_fee = 0;
    if (booking?.fleetadmin && commRateMeter > 0) {
      driver_fee = parseFloat((commBaseMeter / (1 + commRateMeter / 100)).toFixed(2));
      fleetCommission_fee = parseFloat((commBaseMeter - driver_fee).toFixed(2));
    }
    booking.fleetCommission = fleetCommission_fee ? fleetCommission_fee : 0;
    booking.driver_share = driver_fee ? driver_fee : 0;

  }
  return booking;
};

export const updateDriverQueue = (booking) => {

  const { singleUserRef, appcat } = firebase;
  if (appcat === "bidcab") {
    if (booking.status === 'NEW' && booking.driver && booking.prepaid) {
      booking.status = "ACCEPTED";
    }
    update(singleUserRef(booking.driver), { queue: true });
    return booking;
  } else {
    return booking;
  }
};

const { settingsRef, appcat } = firebase;
// const settingsdata = await get(settingsRef);
// const settings = settingsdata.val();
// console.log("App Category:", settings);
export const driverQueue = appcat === "delivery" ? true : false;
export const MAIN_COLOR = "#06113C";
export const SECONDORY_COLOR = "#DDDEEE";
export const FONT_FAMILY = '"Roboto", sans-serif';

export const WEB_MAIN_COLOR = (cat) => {
  if (cat === 'taxi') return "#06113C";
  if (cat === 'delivery') return "#FE805D";
  if (cat === 'bidcab') return "#00564c";
  return "#06113C";
};

export const WEB_SECONDORY_COLOR = (cat) => {
  if (cat === 'taxi') return "#DDDEEE";
  if (cat === 'delivery') return "#E7F1F9";
  if (cat === 'bidcab') return "#eee7ca";
  return "#DDDEEE";
};
